import { createFileRoute } from '@tanstack/react-router';
import { marketingCacheHeaders } from '@/analytics/cache-headers';
import { cookieTrackersLanding } from '@/seo/cookie-trackers-landing';
import * as m from '@/paraglide/messages';
import { seo } from '@/seo/seo';

// **No loader, deliberately — do not add one back without reading this.**
//
// This layout used to call `User.Summary` on every marketing page load to
// resolve the visitor's Stripe `customer_id` for the site-wide ProfitWell
// session. That cost several DB queries per pageview — including for
// anonymous visitors, who are the overwhelming majority and for whom the
// answer is always null — to feed a vendor script that has never worked.
// ProfitWell was removed outright in 2026-07 (WEB-ER).
//
// Removing it has a second, larger payoff: `customer_id` was the ONLY
// per-user value this layout rendered server-side, so marketing responses
// are now identical for every viewer and can be shared-cached at the CDN.
// A loader that resolves anything per-user would silently undo that and
// start serving one visitor's data to the next out of the cache.
//
// If a marketing page ever needs per-user data, fetch it client-side after
// hydration.
export const Route = createFileRoute('/_marketing')({
  // Applies to every marketing route via TanStack's header merge; only paths
  // on the `cached-routes.ts` allow-list actually get a shared TTL.
  headers: marketingCacheHeaders(),
  head: () => ({
    meta: [
      ...seo({
        title: m.meta_homepage_title(),
        description: m.meta_homepage_description(),
      }),
    ],
    scripts: cookieTrackersLanding(),
  }),
});
